import { createFileRoute } from '@tanstack/react-router';
import { redirectContent } from '@/features/artifacts/content-redirect';

// Content became Artifacts (Kazzy, 12 Oct 2026): an old address lands on its deliverables.
export const Route = createFileRoute('/_authed/content')({
  beforeLoad: redirectContent,
});
